// Single source of truth for the app's password policy on the client.
//
// Mirrors the shared rule used across every password-setting endpoint in
// tradiepass-api (register, reset-password, change-password): 8+ characters,
// checked server-side against the Have I Been Pwned breached-password list.
// The length/breach requirements aren't shown inline in the UI — this module
// just backs the live "passwords match" hint.

/**
 * Whether a password and its confirmation currently match. Returns false
 * while the confirmation is still empty, so callers can distinguish
 * "not answered yet" from "answered and matches" (see PasswordMatchHint).
 *
 * @param {string} password
 * @param {string} confirmation
 * @returns {boolean}
 */
export function passwordsMatch(password, confirmation) {
  return !!confirmation && password === confirmation
}
